import module from 'contabilidad/clientescuentascontables/module.js'
import template from './template.html'

export class ContabilidadClientescuentascontablesDetalleCuentasDetalleComponent {
  data
}

module.component('contabilidadClientescuentascontablesDetalle', {
  controller: ContabilidadClientescuentascontablesDetalleCuentasDetalleComponent,
  template,
  bindings: {
    data: '<clientes',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/clientescuentascontables/components/detalle/component.js